import { LoggedInUserInterface } from '../interfaces'
import JwtData from './JwtData'

class Impersonation {
  userData: LoggedInUserInterface
  mainToken: string = ''
  currentToken: string = ''
  mainProvince: string = ''
  currentProvince: string = ''
  mainCity: string = ''
  currentCity: string = ''
  mainMobile: string = ''
  currentMobile: string = ''
  mainPharmacyName: string = ''
  currentPharmacyName: string = ''
  mainCode: string = ''
  currentCode: string = ''

  constructor() {
    const jwtData = new JwtData()
    this.userData = jwtData.userData
    const mtoken = localStorage.getItem('mainToken')
    this.mainToken = mtoken === null ? jwtData.userData.token : mtoken
    const mPhName = localStorage.getItem('mainPharmacyName')
    this.mainPharmacyName =
      mPhName === null ? jwtData.userData.pharmacyName : mPhName
    const mPhMobile = localStorage.getItem('mainPharmacyMobile')
    this.mainMobile = mPhMobile === null ? jwtData.userData.mobile! : mPhMobile
    const mPhProvince = localStorage.getItem('mainPharmacyProvince')
    this.mainProvince =
      mPhProvince === null ? jwtData.userData.pharmacyProvince! : mPhProvince
    const mPhCity = localStorage.getItem('mainPharmacyCity')
    this.mainCity = mPhCity === null ? jwtData.userData.pharmacyCity! : mPhCity
    this.currentToken = jwtData.userData.token
    this.currentPharmacyName = jwtData.userData.pharmacyName

    const mPhCode = localStorage.getItem('mainPharmacyCode')
    this.mainCode = mPhCode === null ? jwtData.userData.pharmacyCode! : mPhCode
    this.currentToken = jwtData.userData.token
   
  }

  changeToken(
    newToken: string,
    newPharmacyName: string,
    newMobile: string,
    newProvince: string,
    newCity: string,
    newCode: string
  ): void {
    this.currentToken = newToken
    this.userData.token = newToken
    const phName =
      newPharmacyName === '' ? this.mainPharmacyName : newPharmacyName
    this.currentPharmacyName = phName
    this.userData.pharmacyName = phName
    localStorage.setItem('mainPharmacyName', this.mainPharmacyName)

    const phMobile = newMobile === '' ? this.mainMobile : newMobile
    this.currentMobile = phMobile
    this.userData.mobile = phMobile
    localStorage.setItem('mainPharmacyMobile', this.mainMobile)

    const phProvince = newProvince === '' ? this.mainProvince : newProvince
    this.currentProvince = phProvince
    this.userData.pharmacyProvince = phProvince
    localStorage.setItem('mainPharmacyProvince', this.mainProvince)

    const phCity = newCity === '' ? this.mainCity : newCity
    this.currentCity = phCity
    this.userData.pharmacyCity = phCity
    localStorage.setItem('mainPharmacyCity', this.mainCity)


    const phCode = newCode === '' ? this.mainCode : newCode
    this.currentCode = phCode
    this.userData.pharmacyCode = phCode
    localStorage.setItem('mainPharmacyCode', this.mainCode)

    localStorage.setItem('mainToken', this.mainToken)
    localStorage.setItem('user', JSON.stringify(this.userData))
  }

  changeTokenToMain(): void {
    this.changeToken(
      this.mainToken,
      this.mainPharmacyName,
      this.currentMobile,
      this.currentProvince,
      this.currentCity,
      this.currentCode
    )
  }
}

export default Impersonation
